import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
	if (process.dev) {
		return
	}

	const environment = useRuntimeConfig().public.environment

	Sentry.init({
		app: nuxtApp.vueApp,
		dsn: 'https://33df2538ed889ca7b0b63a44fb516127@o4506144698859520.ingest.us.sentry.io/4507136431095808',
		integrations: [],
		environment
	})
})
